import jobPlacementLink from '@/_shared/img/job-placement.jpg';

import { globalDataModel } from './global-data-model';

export const leadModelData = {
  id: 'xxxxxx',
  name: 'xxxxx',
  first_name: 'xxxx',
  email: 'xxxxx',
  employer_name: null,
  lead_source: 'xxxx',
  lead_status: 'xxxx',
  street_address: null,
  city: null,
  state: 'xxx',
  zip_code: 'xxxx',
  converted_student_record2: 'xxxxxx',
  campus: null,
  degree: null,
  degree_college: null,
  degree_college_state: null,
  degree_month: null,
  degree_year: null,
  college_gen_ed_credits: null,
  geo_zip_code: 'xxxx',
  degree_of_interest: null,
  degree_subject_of_interest: null,
  general_degree_important_notes: null,
  student_status: 'xxxxx',
  college_of_interest_master: null,
  bridge_plan_url: null,
  smarter: false,
  subscription_plan_link: 'xxxxx',
  bridge_plan_link: 'xxxxx',
  atp_pilot: true,
  atp_pilot_timestamp: 'xxxxx',
  mphone: 'xxxx',

  is_climb_eligible: false,

  campus_to_program: {
    id: 'xxxxxx',
    name: 'xxxxxxx',
    college_website: 'xxxxx',
    college_campus: 'xxxxx',
    college_program: 'xxxx',
    campus_state: 'xxxxx',
    program_status: 'xxxxx',
    campus_zipcode: 'xxxx',
    program: 'xxxxx',
    related_gpoi: 'xxxxx',
    college_name: 'xxxxx',
    courses_list_taken_at_achieve: [
      {
        id: '-1',
        name: 'xxxxxx',
        image: '',
        college_course_name: 'xxxxxx',
        college_credits: 0.0,
        course_length: 0,
        max_time_limit: 0,
        exam_types: 'xxxx',
        exam_fee: 0.0,
        product_type: '',
      },
      {
        id: '-2',
        name: 'xxxxxx',
        image: '',
        college_course_name: 'xxxxxx',
        college_credits: 0.0,
        course_length: 0,
        max_time_limit: 0,
        exam_types: null,
        exam_fee: null,
        product_type: '',
      },
      {
        id: '-3',
        name: 'xxxxxx',
        image: '',
        college_course_name: 'xxxxxx',
        college_credits: 0.0,
        course_length: 0,
        max_time_limit: 0,
        exam_types: null,
        exam_fee: null,
        product_type: '',
      },
      {
        id: '-4',
        name: 'xxxxxx',
        image: '',
        college_course_name: 'xxxxxx',
        college_credits: 0.0,
        course_length: 0,
        max_time_limit: 0,
        exam_types: null,
        exam_fee: null,
        product_type: '',
      },
      {
        id: '-5',
        name: 'xxxxxx',
        image: '',
        college_course_name: 'xxxxxx',
        college_credits: 0.0,
        course_length: 0,
        max_time_limit: 0,
        exam_types: null,
        exam_fee: null,
        product_type: '',
      },
    ],
    courses_list_taken_at_college: [
      {
        id: '-1',
        name: '-1',
        college_course_name: null,
        college_credits: 0,
        course_length: null,
        transfer_in: false,
        transform_from_college: false,
        other_program_course_name: 'Professional Experience',
        other_program_credit_type: 'Professional Experience',
      },
      {
        id: '-2',
        name: '-2',
        college_course_name: null,
        college_credits: 0,
        course_length: null,
        transfer_in: false,
        transform_from_college: false,
        other_program_course_name: null,
        other_program_credit_type: null,
      },
      {
        id: '-3',
        name: '-3',
        college_course_name: null,
        college_credits: 0,
        course_length: null,
        transform_from_college: false,
        transfer_in: false,
        other_program_course_name: null,
        other_program_credit_type: null,
      },
      {
        id: '-4',
        name: '-4',
        college_course_name: null,
        college_credits: 0,
        course_length: null,
        transfer_in: false,
        transform_from_college: false,
        other_program_course_name: null,
        other_program_credit_type: null,
      },
      {
        id: '-5',
        name: '-5',
        college_course_name: null,
        college_credits: 0,
        course_length: null,
        transfer_in: false,
        transform_from_college: false,
        other_program_course_name: null,
        other_program_credit_type: null,
      },
    ],
    optional_courses: [
      {
        id: '-12',
        name: 'xxxxx',
        image: '',
        product_type: 'entrance exam prep course',
        college_course_name: undefined,
        college_credits: undefined,
        course_length: undefined,
        max_time_limit: 0,
        exam_types: null,
        exam_fee: null,
        description: '',
      },
      {
        id: '-13',
        name: 'xxxxx',
        image: '',
        product_type: 'licensing exam prep course',
        college_course_name: 'xxxxx',
        college_credits: 0.0,
        max_time_limit: 0,
        course_length: 4.0,
        exam_types: null,
        exam_fee: null,
        description: '',
      },
    ],
    taken_at_atp_course_savings: 0,
  },

  course_order_info: {
    id: 'xxxxxx',
    order_data: {
      ...globalDataModel,
    },
    lead_id: '',
    created_on: '',
    modified_on: '',
  },

  account_charge: 0,
};

export type TLeadModelData = typeof leadModelData;
export type TAtpCourseData = TLeadModelData['campus_to_program']['courses_list_taken_at_achieve'][number];
export type TCollegeCourseData = TLeadModelData['campus_to_program']['courses_list_taken_at_college'][number];
export type TAtpOptionalCourseData = TLeadModelData['campus_to_program']['optional_courses'][number];

export const atpOptionalStaticData: TAtpOptionalCourseData[] = [
  {
    id: 'JOB_PLACEMENT',
    name: 'Career Guidance',
    image: jobPlacementLink,
    product_type: 'job placement',
    college_course_name: '',
    college_credits: 0,
    course_length: 0,
    max_time_limit: 0,
    exam_types: null,
    exam_fee: null,
    description: 'Strengthen your resume and interviewing skills, and learn to market yourself online.',
  },
];
